import { environment } from '../../app.environment';

export function isDevelopmentProject(): boolean {
  return environment.firebase.projectId === 'in-time-fa9b7';
}
